import appFulfillmentPlan from "../../views/appPlans/fulfillmentPlanView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("fulfillmentplan", {
    url: "fulfillment-plan/:id",
    parent: "app",
    views: {
      view: {
        template: appFulfillmentPlan,
      },
    },
    reloadOnSearch: false,
    data: { title: "FulfillmentPlan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/fulfillmentPlan.urls.js